import { render, staticRenderFns } from "./AppHeaderBlack.vue?vue&type=template&id=b8d9c242&scoped=true&"
import script from "./AppHeaderBlack.vue?vue&type=script&lang=js&"
export * from "./AppHeaderBlack.vue?vue&type=script&lang=js&"
import style0 from "./AppHeaderBlack.vue?vue&type=style&index=0&id=b8d9c242&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d9c242",
  null
  
)

export default component.exports